const PRODUCT_CODE_ID_DIFF = 10000;

export const getProductIdFromProductCode = (productCode: number) =>
  productCode - PRODUCT_CODE_ID_DIFF;

export const getProductCodeFromProductId = (productId: number) => productId + PRODUCT_CODE_ID_DIFF;
